module.exports = {
  context: {
    image: {
      src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/catalyst-community-services.jpg?mtime=20210607142855&focal=none',
      alt: 'Surfer with surfboard',
      lazy: true
    },
    heading: 'Catalyst Community Services',
    shortDescription: 'We help people within the full spectrum of types of disabilities. Our staff is committed to people with disabilities to help them succeed in their daily lives, work, home and in their communities',
    button: {
      text: 'Learn More',
      url: 'https://google.com',
      class: 'cta'
    }
  }
}
